module.exports = __webpack_public_path__ + "static/media/starting2.41560896.ogg";